import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';

export const FA_TOOLTIPS_CONFIG = {
  provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
  useValue: {
    disableTooltipInteractivity: true,
  },
};
